import React from "react";
import useMediaQuery from '@mui/material/useMediaQuery';
import { responsiveFont, responsivePaddingVertical, responsivePaddingHorizontal } from '../../common/responsive.utils';

const Component04 = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles(); 

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.divSty_Web}> 
                        <div style={styles.divMargin_Web} >
                            <span style={styles.titleTxt_Web}>
                                5만 명이 넘는 반려인을 <br /> 내 매장의 고객으로 만들어 보세요
                            </span>
                        </div>

                        <div style={styles.divRow_Web}>
                            <div style={styles.divColumn_Web}>
                                <span style={styles.titleTxt01_Web}>
                                    우주펫 반려인 수
                                </span>

                                <span style={styles.titleTxt02_Web}>
                                    약 50,000명 +
                                </span>
                            </div>
                            <div style={styles.divColumn_Web}>
                                <span style={styles.titleTxt01_Web}>
                                    월 돌봄 신청 수
                                </span>

                                <span style={styles.titleTxt02_Web}>
                                    약 1,000건 +
                                </span>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div style={styles.componentIntro_Mobile} >
                        <p style={styles.componentIntroTitleTxt_Mobile}>
                            5만 명이 넘는 반려인을 <br />
                            내 매장의 고객으로 <br />
                            만들어 보세요
                        </p>

                        <div style={{ height: "3vh" }} />

                        <div style={styles.txtDiv_Mobile}>
                            <div style={{ height: "3.4483vh" }} />
                            <p style={styles.introTxt_Mobile} >
                                우주펫 반려인 수
                            </p>
                            <div style={{ height: "0.5172vh" }} />
                            <p style={styles.introContentTxt_Mobile}>
                                약 50,000명 +
                            </p>

                            <div style={{ height: "3.4483vh" }} />
                            <p style={styles.introTxt_Mobile} >
                                월 돌봄 신청 수
                            </p>
                            <div style={{ height: "0.5172vh" }} />
                            <p style={styles.introContentTxt_Mobile}>
                                약 1,000건 +
                            </p>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    divSty_Web: { backgroundColor: "#FFFFF", display: "flex", flexDirection: "column", paddingBottom: responsivePaddingVertical(50, 90), paddingTop: responsivePaddingVertical(50, 90), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88)},
    divMargin_Web: {marginBottom: "65px" },
    divRow_Web: { display: "flex", flexDirection: "row", justifyContent: "space-evenly" },
    divColumn_Web: { display: "flex", flexDirection: "column", },
    titleTxt_Web: { fontFamily: "Pretendard", fontWeight: 800, fontSize: responsiveFont(22, 40), lineHeight: "140%", letterSpacing: "-1%", color:"black" },
    titleTxt01_Web: { fontFamily: "Pretendard", fontWeight: 700, fontSize: responsiveFont(16, 30), lineHeight: "120%", letterSpacing: "-1%", color: "#8B4DFF", paddingBottom: "15px" },
    titleTxt02_Web: { fontFamily: "Pretendard", fontWeight: 700, fontSize: responsiveFont(22, 43), lineHeight: "140%", letterSpacing: "-3%", color: "black", paddingBottom: "50px" },

    componentIntro_Mobile: { width: "100%", minWidth: "320px", backgroundColor: "#FFFFF", paddingBottom: responsivePaddingVertical(50, 90), paddingTop: responsivePaddingVertical(50, 90), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88), margin: 0, boxSizing: "border-box", },
    componentIntroTitleTxt_Mobile: { fontFamily: "'Pretendard'", fontWeight: 700, fontSize: responsiveFont(22, 40), lineHeight: "140%", letterSpacing: "-1%", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "black", margin: 0, padding: 0, },
    txtDiv_Mobile: { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", },
    introTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(16, 30), lineHeight: "120%", fontWeight: 700, letterSpacing: "-1%", textAlign: "center", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#8B4DFF", textShadow: "none", margin: 0, padding: 0, },
    introContentTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(22, 43), lineHeight: "140%", fontWeight: 700, letterSpacing: "-3%", textAlign: "center", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#1B1D1F", textShadow: "none", margin: 0, padding: 0, },
});

export default Component04;